export default __webpack_public_path__ + "static/media/deep_dao_logo_white.e737e9b6.svg";